import { render } from "./ShippingData.vue?vue&type=template&id=20e4df36&scoped=true"
import script from "./ShippingData.vue?vue&type=script&lang=js"
export * from "./ShippingData.vue?vue&type=script&lang=js"

import "./ShippingData.vue?vue&type=style&index=0&id=20e4df36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e4df36"]])

export default __exports__